import { Layer, Source } from 'react-map-gl/mapbox';
import { useMapboxStore } from '../store';

export default function CurrentRoute() {
  const { currentRoute } = useMapboxStore();

  if (!currentRoute) return null;

  return (
    <Source id="route" type="geojson" data={currentRoute}>
      <Layer id="route-layer" type="line" paint={{ 'line-color': '#0494FE', 'line-width': 4 }} />
    </Source>
  );
}
